<template>
  <div class="modal_wrapper active">
    <div
      id="create_report"
      class="modal_window white_box create_report_modal"
    >
      <div
        v-show="currentStep <= 2"
        class="report_steps_wrapper"
      >
        <div class="header-wrapper">
          <h4 class="heading_h4 font_bold mb_16">
            Create new {{ type }}
          </h4>
          <div
            v-if="user.ga_version && type === 'template'"
            class="pb_small mt_8 ga_version_info"
          >
            This template will be created using Google Analytics {{ user.ga_version === 'ga3' ? 'V3' : 'V4' }}
          </div>
          <button
            class="close_modal close_btn"
            @click="closeModal()"
          >
            <svg
              fill="none"
              height="32"
              viewBox="0 0 32 32"
              width="32"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M25 7L7 25"
                stroke="#040707"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
              <path
                d="M25 25L7 7"
                stroke="#040707"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
              />
            </svg>
          </button>
        </div>

        <div
          v-show="currentStep === 1"
          class="create_report_choose white_box"
        >
          <h5 class="heading_h4 font_bold">
            How do you want to create your {{ type }}?
          </h5>
          <div class="p_small mb_16">
            Choose to start fresh with a blank report, use one of your own templates or one of
            ours
          </div>
          <div class="flex choose_report_type">
            <div
              :class="'white_box report_type_item '+(data.from === 'blank' ? 'choosed' : '')"
              @click="data.from = 'blank'; nextStep(currentStep);"
            >
              <div class="icon mb_16">
                <svg
                  fill="none"
                  height="32"
                  viewBox="0 0 32 32"
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M25 28H6.99902C6.73381 28 6.47945 27.8946 6.29192 27.7071C6.10438 27.5196 5.99902 27.2652 5.99902 27V5C5.99902 4.73478 6.10438 4.48043 6.29192 4.29289C6.47945 4.10536 6.73381 4 6.99902 4H19L26 11V27C26 27.1313 25.9741 27.2614 25.9239 27.3827C25.8736 27.504 25.8 27.6143 25.7071 27.7071C25.6143 27.8 25.504 27.8736 25.3827 27.9239C25.2614 27.9741 25.1313 28 25 28Z"
                    stroke="#37B2A8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  />
                  <path
                    d="M19 4V11H26.001"
                    stroke="#37B2A8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  />
                </svg>
              </div>
              <div>
                <div class="heading_h5 font_bold mb_4">
                  Create a blank {{ type }}
                </div>
                <p class="p_small">
                  Start fresh from a clean slate and add sections.
                </p>
              </div>
            </div>
            <div
              :class="'white_box report_type_item '+(data.from === 'template' ? 'choosed' : '')"
              @click="data.from = 'template'; nextStep(currentStep);"
            >
              <div class="icon mb_16">
                <svg
                  fill="none"
                  height="32"
                  viewBox="0 0 32 32"
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M25 28H6.99902C6.73381 28 6.47945 27.8946 6.29192 27.7071C6.10438 27.5196 5.99902 27.2652 5.99902 27V5C5.99902 4.73478 6.10438 4.48043 6.29192 4.29289C6.47945 4.10536 6.73381 4 6.99902 4H19L26 11V27C26 27.1313 25.9741 27.2614 25.9239 27.3827C25.8736 27.504 25.8 27.6143 25.7071 27.7071C25.6143 27.8 25.504 27.8736 25.3827 27.9239C25.2614 27.9741 25.1313 28 25 28Z"
                    stroke="#37B2A8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  />
                  <path
                    d="M19 4V11H26.001"
                    stroke="#37B2A8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  />
                  <path
                    d="M12 17H20"
                    stroke="#37B2A8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  />
                  <path
                    d="M12 21H20"
                    stroke="#37B2A8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  />
                </svg>
              </div>
              <div>
                <div class="heading_h5 font_bold mb_4">
                  Start from a template
                </div>
                <p class="p_small">
                  Use a premade template or one of your own.
                </p>
              </div>
            </div>
            <div
              v-if="reports && reports.length > 0"
              :class="'white_box report_type_item '+(data.from === 'report' ? 'choosed' : '')"
              @click="data.from = 'report'; nextStep(currentStep);"
            >
              <div class="icon mb_16">
                <svg
                  fill="none"
                  height="32"
                  viewBox="0 0 32 32"
                  width="32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23 30H4.99902C4.73381 30 4.47945 29.8946 4.29192 29.7071C4.10438 29.5196 3.99902 29.2652 3.99902 29V7C3.99902 6.73478 4.10438 6.48043 4.29192 6.29289C4.47945 6.10536 4.73381 6 4.99902 6H17L24 13V29C24 29.1313 23.9741 29.2614 23.9239 29.3827C23.8736 29.504 23.8 29.6143 23.7071 29.7071C23.6143 29.8 23.504 29.8736 23.3827 29.9239C23.2614 29.9741 23.1313 30 23 30Z"
                    stroke="#37B2A8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  />
                  <path
                    d="M8 6V3C8 2.73478 8.10536 2.48043 8.29289 2.29289C8.48043 2.10536 8.73478 2 9 2H21.001L28.001 9V25C28.001 25.1313 27.9751 25.2614 27.9249 25.3827C27.8746 25.504 27.8009 25.6143 27.7081 25.7071C27.6152 25.8 27.505 25.8736 27.3837 25.9239C27.2623 25.9741 27.1323 26 27.001 26H24"
                    stroke="#37B2A8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  />
                  <path
                    d="M17 6V13H24.001"
                    stroke="#37B2A8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  />
                  <path
                    d="M10 19H18"
                    stroke="#37B2A8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  />
                  <path
                    d="M10 23H18"
                    stroke="#37B2A8"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                  />
                </svg>
              </div>
              <div>
                <div class="heading_h5 font_bold mb_4">
                  Clone an existing report
                </div>
                <p class="p_small">
                  Duplicate a previous report and edit/add sections.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          v-show="currentStep === 1.2"
          class="create_report_choose white_box mb_16"
        >
          <h5 class="heading_h4 font_bold">
            Select a Report Template
          </h5>
          <div
            v-if="canEditTemplates"
            class="p_small mb_16"
          >
            Visit the <a href="/reports?table=templates">templates
              page</a> to create your own.
          </div>
          <div
            v-if="showGAVersionWarning"
            class="p_small ga_version_warning"
          >
            This template uses Google Analytics {{ data.ga_version === 'ga3' ? 'V3' : 'V4' }} widgets, whereas your
            active website is connected to Google Analytics {{ user.ga_version === 'ga3' ? 'V3' : 'V4' }}.<br>
            Any Google Analytics widgets will need to be removed and replaced with
            {{ user.ga_version === 'ga3' ? 'V3' : 'V4' }} widgets.
          </div>
          <div class="flex step_one_settings">
            <div class="create_settings">
              <form
                class="search_component_form"
                @submit.prevent="() => undefined"
              >
                <input
                  v-model="templateSearchInput"
                  autocomplete="off"
                  class="input_styles search_icon"
                  placeholder="Search Templates"
                  type="search"
                >
              </form>
              <div
                id="templates_names_list"
                class="names_list p_small"
              >
                <div
                  v-for="(template, index) in filteredTemplates"
                  :id="template.id"
                  :key="index"
                  :class="'name_item '+(data.from === 'template' && data.id === template.id ? 'selected' : '')"
                  @click="
                    data.id = template.id;
                    clearRequiredField('id');
                    useExisting(template);
                  "
                >
                  <span class="pseudo_check" />
                  <span class="name">{{ template.name }}</span>
                </div>
                <div
                  v-if="allTemplates.length === 0"
                  class="name_item loading"
                >
                  <span class="name">Loading Templates ...</span>
                </div>
                <div
                  v-if="templateSearchInput !== '' && filteredTemplates.length === 0"
                  class="name_item"
                >
                  <span class="name">No templates found...</span>
                </div>
              </div>
            </div>
          </div>
          <small
            v-if="requiredFields.includes('id')"
            class="selection_warning"
          >Please select one of the
            templates</small>
        </div>

        <div
          v-show="currentStep === 1.3"
          class="create_report_choose white_box mb_16"
        >
          <h5 class="heading_h4 font_bold">
            Clone an Existing Report
          </h5>
          <div class="p_small mb_16">
            Start with a report you’ve already created.
          </div>
          <div class="flex step_one_settings">
            <div class="create_settings">
              <form class="search_component_form">
                <input
                  autocomplete="off"
                  class="input_styles search_icon"
                  placeholder="Search Reports"
                  type="search"
                >
              </form>
              <div
                id="reports_names_list"
                class="names_list p_small"
              >
                <div
                  v-for="report in allReports"
                  :id="report.id"
                  :key="report.id"
                  :class="'name_item '+(data.from === 'report' && data.id === report.id ? 'selected' : '')"
                  @click="
                    data.id = report.id;
                    clearRequiredField('id');
                    useExisting(report)
                  "
                >
                  <span class="pseudo_check" />
                  <span class="name">{{ report.name }}</span>
                </div>
              </div>
            </div>
          </div>
          <small
            v-if="requiredFields.includes('id')"
            class="selection_warning"
          >Please select one of the reports</small>
        </div>

        <div class="content_wrap">
          <div
            v-show="currentStep === 2"
            :class="'section_wrap '+(settings === 'report' ? 'open' : '')"
          >
            <div
              class="section_head"
              @click="(settings === 'report' ? settings = '' : settings = 'report')"
            >
              <h3 class="section_heading">
                Report Settings
              </h3>
              <div class="section_icons">
                <div
                  v-if="reportErrors.length"
                  class="errors"
                >
                  {{ reportErrors.length }}
                </div>
                <i class="icon arrow_down_icon caret" />
              </div>
            </div>
            <accordion-transition>
              <div
                v-if="settings === 'report'"
                class="section_body"
              >
                <custom-input
                  v-model="data.name"
                  :label="`${type === 'report' ? 'Report' : 'Template'} name`"
                  :placeholder="`Please add a name for your ${type}`"
                  :validation-errors="errors.name"
                  width="full"
                />

                <custom-select
                  v-model="data.paper_size"
                  :options="['A4', 'Letter']"
                  :validation-errors="errors.paper_size"
                  label="Paper size"
                  width="half"
                />

                <custom-select
                  v-model="data.orientation"
                  :options="{
                    'portrait': 'Portrait',
                    'landscape': 'Landscape'
                  }"
                  :validation-errors="errors.orientation"
                  label="Page orientation"
                  width="half"
                />

                <custom-select
                  v-model="data.font"
                  :options="[
                    { value: 'DM Sans, sans-serif', label: 'DM Sans', font: 'DM Sans, sans-serif'},
                    { value: 'Arial, Helvetica, sans-serif', label: 'Arial', font: 'Arial, Helvetica, sans-serif'},
                    { value: 'Cambria, Cochin, Georgia, Times, Times New Roman, serif', label: 'Cambria', font: 'Cambria, Cochin, Georgia, Times, Times New Roman, serif'},
                    { value: 'Courier New, Courier, monospace', label: 'Courier New', font: 'Courier New, Courier, monospace'},
                    { value: 'Franklin Gothic Medium, Arial Narrow, Arial, sans-serif', label: 'Franklin Gothic Medium', font: 'Franklin Gothic Medium, Arial Narrow, Arial, sans-serif'},
                    { value: 'Lucida Sans, Lucida Sans Regular, Lucida Grande, Lucida Sans Unicode, Geneva, Verdana, sans-serif', label: 'Lucida Sans', font: 'Lucida Sans, Lucida Sans Regular, Lucida Grande, Lucida Sans Unicode, Geneva, Verdana, sans-serif'},
                    { value: 'Roboto, -apple-system, system-ui, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif', label: 'Roboto', font: 'Roboto, -apple-system, system-ui, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif'},
                    { value: 'Times New Roman, Times, serif', label: 'Times New Roman', font: 'Times New Roman, Times, serif'}
                  ]"
                  label="Report font"
                  width="half"
                />

                <custom-select
                  v-model="data.date_format"
                  :options="[
                    'DD/MM/YYYY',
                    'DD-MM-YYYY',
                    'DD.MM.YYYY',
                    'MM/DD/YYYY',
                    'MM-DD-YYYY',
                    'MM.DD.YYYY'
                  ]"
                  :validation-errors="errors.date_format"
                  label="Date format"
                  width="half"
                />

                <custom-input
                  :disabled="true"
                  :placeholder="selectedDateRange"
                  :width="data.comp_range ? 'third' : 'half'"
                  label="Date range"
                />

                <custom-input
                  v-if="data.comp_range"
                  :disabled="true"
                  :placeholder="selectedCompRange"
                  label="Comparison date range"
                  width="third"
                />

                <button
                  :class="'btn secondary_btn open-datepicker '+(data.comp_range ? 'third' : 'half')"
                  @click="datepicker = true"
                >
                  <span>Select Date Range</span>
                </button>

                <date-range-picker
                  v-if="datepicker"
                  v-model:compFromDate="data.comp_from_date"
                  v-model:compRange="data.comp_range"
                  v-model:compToDate="data.comp_to_date"
                  v-model:dateRange="data.date_range"
                  v-model:fromDate="data.from_date"
                  v-model:toDate="data.to_date"
                  @close="datepicker = false"
                />

                <custom-select
                  v-if="type === 'template' && canSetScope"
                  v-model="data.scope"
                  :options="scopes"
                  :validation-errors="errors.scope"
                  label="Template scope"
                  width="full"
                />

                <custom-color-multiselect
                  v-model="data.colors"
                  :validation-errors="errors.colors"
                  label="Report Chart Colors"
                  width="full"
                />
              </div>
            </accordion-transition>
          </div>

          <div
            v-show="currentStep === 2"
            :class="'section_wrap '+(settings === 'header' ? 'open' : '')"
          >
            <div
              class="section_head"
              @click="(settings === 'header' ? settings = '' : settings = 'header')"
            >
              <h3 class="section_heading">
                Header Settings
              </h3>
              <div class="section_icons">
                <div
                  v-if="headerErrors.length"
                  class="errors"
                >
                  {{ headerErrors.length }}
                </div>
                <i class="icon arrow_down_icon caret" />
              </div>
            </div>
            <accordion-transition>
              <div
                v-if="settings === 'header'"
                class="section_body"
              >
                <div class="logo_preview">
                  <img
                    v-if="data.logo_src"
                    :src="data.logo_src"
                    :style="`background: ${data.header_color ?? 'lightgray'};`"
                  >
                  <div v-else>
                    Please upload a logo. Images will be scaled to fit the header
                  </div>

                  <custom-image-upload
                    v-model="data.logo_src"
                    :label="data.logo_src ? 'Change logo' : 'Upload a logo' "
                    width="full"
                  />
                </div>
                <small
                  v-if="errors.logo_src"
                  class="selection_warning"
                >{{ errors.logo_src ? errors.logo_src[0] : '' }}</small>

                <custom-input
                  v-model="data.header_text"
                  :validation-errors="errors.header_text"
                  label="Header text"
                  placeholder="Enter your header text"
                />

                <custom-color-select
                  v-model="data.header_color"
                  :validation-errors="errors.header_color"
                  label="Header color"
                  placeholder="Enter a hex value E.g. #ffffff"
                  width="half"
                />

                <custom-color-select
                  v-model="data.header_text_color"
                  :validation-errors="errors.header_text_color"
                  label="Header text color"
                  placeholder="Enter a hex value E.g. #ffffff"
                  width="half"
                />

                <custom-select
                  v-model="data.header_font"
                  :options="[
                    { value: 'DM Sans, sans-serif', label: 'DM Sans', font: 'DM Sans, sans-serif'},
                    { value: 'Arial, Helvetica, sans-serif', label: 'Arial', font: 'Arial, Helvetica, sans-serif'},
                    { value: 'Cambria, Cochin, Georgia, Times, Times New Roman, serif', label: 'Cambria', font: 'Cambria, Cochin, Georgia, Times, Times New Roman, serif'},
                    { value: 'Courier New, Courier, monospace', label: 'Courier New', font: 'Courier New, Courier, monospace'},
                    { value: 'Franklin Gothic Medium, Arial Narrow, Arial, sans-serif', label: 'Franklin Gothic Medium', font: 'Franklin Gothic Medium, Arial Narrow, Arial, sans-serif'},
                    { value: 'Lucida Sans, Lucida Sans Regular, Lucida Grande, Lucida Sans Unicode, Geneva, Verdana, sans-serif', label: 'Lucida Sans', font: 'Lucida Sans, Lucida Sans Regular, Lucida Grande, Lucida Sans Unicode, Geneva, Verdana, sans-serif'},
                    { value: 'Roboto, -apple-system, system-ui, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif', label: 'Roboto', font: 'Roboto, -apple-system, system-ui, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif'},
                    { value: 'Times New Roman, Times, serif', label: 'Times New Roman', font: 'Times New Roman, Times, serif'}
                  ]"
                  :validation-errors="errors.header_font"
                  label="Header font"
                  width="half"
                />

                <custom-toggle
                  v-model="data.include_date_range"
                  :validation-errors="errors.include_date_range"
                  label="Include date range"
                  width="half"
                />
              </div>
            </accordion-transition>
          </div>

          <div
            v-show="currentStep === 2"
            :class="'section_wrap '+(settings === 'footer' ? 'open' : '')"
          >
            <div
              class="section_head"
              @click="(settings === 'footer' ? settings = '' : settings = 'footer')"
            >
              <h3 class="section_heading">
                Footer Settings
              </h3>
              <div class="section_icons">
                <div
                  v-if="footerErrors.length"
                  class="errors"
                >
                  {{ footerErrors.length }}
                </div>
                <i class="icon arrow_down_icon caret" />
              </div>
            </div>
            <accordion-transition>
              <div
                v-if="settings === 'footer'"
                class="section_body"
              >
                <custom-input
                  v-model="data.footer_text"
                  :validation-errors="errors.footer_text"
                  label="Footer text"
                  placeholder="Enter your footer text"
                />

                <custom-color-select
                  v-model="data.footer_color"
                  :validation-errors="errors.footer_color"
                  label="Footer color"
                  placeholder="Enter a hex value E.g. #ffffff"
                  width="half"
                />

                <custom-color-select
                  v-model="data.footer_text_color"
                  :validation-errors="errors.footer_text_color"
                  label="Footer text color"
                  placeholder="Enter a hex value E.g. #ffffff"
                  width="half"
                />

                <custom-select
                  v-model="data.footer_font"
                  :options="[
                    { value: 'DM Sans, sans-serif', label: 'DM Sans', font: 'DM Sans, sans-serif'},
                    { value: 'Arial, Helvetica, sans-serif', label: 'Arial', font: 'Arial, Helvetica, sans-serif'},
                    { value: 'Cambria, Cochin, Georgia, Times, Times New Roman, serif', label: 'Cambria', font: 'Cambria, Cochin, Georgia, Times, Times New Roman, serif'},
                    { value: 'Courier New, Courier, monospace', label: 'Courier New', font: 'Courier New, Courier, monospace'},
                    { value: 'Franklin Gothic Medium, Arial Narrow, Arial, sans-serif', label: 'Franklin Gothic Medium', font: 'Franklin Gothic Medium, Arial Narrow, Arial, sans-serif'},
                    { value: 'Lucida Sans, Lucida Sans Regular, Lucida Grande, Lucida Sans Unicode, Geneva, Verdana, sans-serif', label: 'Lucida Sans', font: 'Lucida Sans, Lucida Sans Regular, Lucida Grande, Lucida Sans Unicode, Geneva, Verdana, sans-serif'},
                    { value: 'Roboto, -apple-system, system-ui, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif', label: 'Roboto', font: 'Roboto, -apple-system, system-ui, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif'},
                    { value: 'Times New Roman, Times, serif', label: 'Times New Roman', font: 'Times New Roman, Times, serif'}
                  ]"
                  :validation-errors="errors.footer_font"
                  label="Footer font"
                  width="half"
                />

                <custom-toggle
                  v-model="data.include_page_no"
                  label="Include page numbers"
                  width="half"
                />
              </div>
            </accordion-transition>
          </div>
        </div>

        <div
          v-if="currentStep <= 2"
          class="flex mt_24 items-center create_report_footer"
        >
          <div class="create_steps mr_auto flex items-center">
            <div :class="'step_item '+(currentStep < 2 ? 'current' : currentStep >= 2 ? 'completed' : '')">
              <i>1</i>
              <span>Source</span>
            </div>
            <div :class="'step_item '+(currentStep === 2 ? 'current' : currentStep === 3 ? 'completed' : '')">
              <i>2</i>
              <span>Design</span>
            </div>
          </div>
          <div class="flex items-center">
            <button
              v-if="currentStep > 1 && currentStep < 2"
              class="btn secondary_btn btn_md close_modal"
              @click="previousStep(currentStep)"
            >
              <span class="heading_h5 font_bold">Back</span>
            </button>
            <button
              v-if="currentStep > 1 && currentStep < 2"
              :disabled="!data.id"
              class="btn btn_md primary_btn mr_2"
              @click="nextStep(currentStep)"
            >
              <span class="p_body font_bold">Next</span>
            </button>
            <button
              v-if="currentStep === 2"
              class="btn btn_md primary_btn"
              @click="create()"
            >
              <span class="p_body font_bold">Create</span>
            </button>
          </div>
        </div>
      </div>

      <div
        v-show="currentStep >= 3"
        class="create_report_final report_final"
      >
        <div>
          <img
            alt=""
            src="img/create_report_final.svg"
          >
        </div>

        <div
          v-if="currentStep === 3"
          class="heading_h3 font_bold mt_24"
        >
          Creating your {{ type }}...
        </div>

        <div
          v-if="currentStep === 4"
          class="heading_h3 font_bold mt_24"
        >
          {{ type === 'report' ? 'Report' : 'Template' }}
          created successfully
        </div>
        <div
          v-if="currentStep === 4"
          class="final-nav-buttons"
        >
          <button
            class="btn secondary_btn btn_md close_modal"
            @click="closeModal()"
          >
            <span class="heading_h5 font_bold">Close</span>
          </button>
          <a
            :href="`/reports/builder/${type}/${report_id}`"
            class="btn btn_md primary_btn"
          >
            <span class="p_body font_bold">Go to {{ type }}</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import _ from 'lodash';
import CustomInput from '../../global/forms/CustomInput.vue';
import CustomSelect from '../../global/forms/CustomSelect.vue';
import CustomColorSelect from '../../global/forms/CustomColorSelect.vue';
import CustomColorMultiselect from '../../global/forms/CustomColorMultiselect.vue';
import CustomImageUpload from '../../global/forms/CustomImageUpload.vue';
import CustomToggle from '../../global/forms/CustomToggle.vue';
import DateRangePicker from '../../global/forms/DateRangePicker.vue';
import AccordionTransition from '../../global/transitions/AccordionTransition.vue';
import {mapActions, mapState} from 'vuex';

export default {
  components: {
    CustomInput,
    CustomSelect,
    CustomColorSelect,
    CustomColorMultiselect,
    CustomImageUpload,
    CustomToggle,
    DateRangePicker,
    AccordionTransition
  },
  props: {
    type: {
      type: String,
      required: true
    },
    reports: {
      type: Array,
      required: true
    },
    templates: {
      type: Array,
      required: true
    },
    createFirst: {
      type: String,
      default: ''
    },
    createFrom: {
      type: Object,
      default: null
    }
  },
  emits: ['close'],
  data() {
    return {
      currentStep: 1,
      datepicker: false,
      settings: 'report',
      errors: {},
      requiredFields: [],
      data: {
        name: '',
        from: null,
        id: null,
        ga_version: '',
        scope: 'website',
        orientation: 'portrait',
        paper_size: 'A4',
        font: 'DM Sans, sans-serif',
        colors: [],
        logo_src: '',
        header_color: '#f3625a',
        header_text: '',
        header_text_color: '#ffffff',
        header_font: 'DM Sans, sans-serif',
        include_date_range: true,
        date_format: 'DD/MM/YYYY',
        footer_color: '#f3625a',
        footer_text: '',
        footer_text_color: '#ffffff',
        footer_font: 'DM Sans, sans-serif',
        include_page_no: true,
        date_range: 'custom',
        comp_range: null,
        from_date: moment().subtract(8, 'd').format('YYYY-MM-DD'),
        to_date: moment().subtract(1, 'd').format('YYYY-MM-DD'),
        comp_from_date: null,
        comp_to_date: null,
      },
      report_id: null,
      created: false,
      allReports: [],
      allTemplates: [],
      templateSearchInput: '',
    }
  },
  computed: {
    ...mapState('user', ['user']),
    selectedDateRange() {
      if (this.data.from_date && this.data.to_date) {
        let from = moment(this.data.from_date).format(this.data.date_format);
        let to = moment(this.data.to_date).format(this.data.date_format);
        return from + ' - ' + to;
      }

      return 'Please select dates';
    },
    selectedCompRange() {
      if (this.data.comp_from_date && this.data.comp_to_date) {
        let from = moment(this.data.comp_from_date).format(this.data.date_format);
        let to = moment(this.data.comp_to_date).format(this.data.date_format);
        return from + ' - ' + to;
      }
      return 'Please select dates';
    },
    dateRange() {
      if (this.data.include_date_range) {
        return moment(this.data.from_date).format(this.data.date_format) + ' - ' + moment(this.data.to_date).format(this.data.date_format);
      }
      return null;
    },
    compRange() {
      if (this.data.include_date_range) {
        let compRange = null;

        if (this.data.comp_range && this.data.comp_range !== 'custom') {
          compRange = _.capitalize(this.data.comp_range).replace(/_/g, ' ');

        } else if (this.data.comp_range && this.data.comp_range === 'custom') {
          compRange = moment(this.data.comp_from_date).format(this.data.date_format) + ' - ' + moment(this.data.comp_to_date).format(this.data.date_format);
        }

        return compRange;
      }
      return null;
    },
    reportErrors() {
      let fields = ['name', 'paper_size', 'orientation', 'colors'];
      let errors = [];
      _.forEach(this.errors, (error, key) => {
        if (fields.includes(key)) errors.push(key);
      });
      return errors;
    },
    headerErrors() {
      let fields = ['header_color', 'logo_src', 'header_text', 'header_color', 'header_text_color', 'header_font', 'include_date_range'];
      let errors = [];
      _.forEach(this.errors, (error, key) => {
        if (fields.includes(key)) errors.push(key);
      });
      return errors;
    },
    footerErrors() {
      let fields = ['footer_text', 'footer_color', 'footer_text_color', 'footer_font'];
      let errors = [];
      _.forEach(this.errors, (error, key) => {
        if (fields.includes(key)) errors.push(key);
      });
      return errors;
    },
    canSetScope() {
      const {user} = this;
      const organisation = user?.organisation;
      return organisation.organisation_type === 'MULTI'
        || organisation.external_id?.startsWith('VEND_')
        || user.user_type === 'ADMIN'
        || organisation.is_multi;
    },
    scopes() {
      const {user} = this;
      const organisation = user?.organisation;
      let scopes = {website: 'Website'};

      if (
        organisation.organisation_type === 'MULTI'
        || organisation.external_id?.startsWith('VEND_')
        || organisation.is_multi
      ) {
        scopes.organisation = 'Organisation';
      }

      if (user.user_type === "ADMIN") {
        scopes.local = 'Local';
      }

      return scopes;
    },
    showGAVersionWarning() {
      return !!(
          this.data.contains_ga_widgets &&
          this.data.from === 'template' &&
          this.data.ga_version &&
          this.data.ga_version !== this.user.ga_version
      );
    },
    canEditTemplates() {
      return this?.user?.permissions?.report_templates_permission === 'EDIT' ?? false;
    },
    filteredTemplates() {
      if(this.templateSearchInput === '') {
        return this.allTemplates;
      }

      return this.allTemplates.filter((template) => {
        return template.name.toLowerCase().includes(this.templateSearchInput.toLowerCase());
      });
    }
  },
  watch: {
    'data.font': {
      handler(a) {
        this.data.header_font = this.data.footer_font = a;
      }
    }
  },
  mounted() {
    axios.get(`/ajax/reports/get-my-reports?all_results=true`).then(res => {
      this.allReports = res.data;
    });
    axios.get(`/ajax/reports/get-my-templates?all_results=true`).then(res => {
      this.allTemplates = res.data;
    });
    this.data.header_text = _.toUpper(this.user.active_website.simple_url) + ' Report';
    if (this.createFirst) {
      this.data.from = this.createFirst;
      this.nextStep(this.currentStep);
    }
    if (this.createFrom) {
      this.useExisting(this.createFrom);
      this.nextStep(1.2);
    }
    if (this.user.organisation.operation_country === 'United States') {
      this.data.date_format = 'MM/DD/YYYY';
    }
  },
  methods: {
    ...mapActions({
      createReport: 'reports/createReport',
      createTemplate: 'templates/createTemplate'
    }),
    validate(fieldName) {
      if (!this.data[fieldName] || this.data[fieldName].length === 0) {
        this.requiredFields.push(fieldName);
        return false;
      }
      return true;
    },
    clearRequiredField(field) {
      if (this.requiredFields.indexOf(field) >= 0) {
        this.requiredFields.splice(this.requiredFields.indexOf(field), 1);
      }
    },
    nextStep(currentStep) {
      switch (currentStep) {
        case 1:
          if (this.data.from === 'blank') this.currentStep = 2;
          if (this.data.from === 'template') this.currentStep = 1.2;
          if (this.data.from === 'report') this.currentStep = 1.3;
          break;
        case 1.2:
        case 1.3:
          this.currentStep = 2;
          break;
        case 2:
          this.currentStep = 3;
          break;
      }

    },
    previousStep(currentStep) {
      switch (currentStep) {
        case 3.3:
          this.currentStep = 3.2;
          break;
        case 3.2:
          this.currentStep = 3.1;
          break;
        case 3.1:
          this.currentStep = 2;
          break;
        case 2:
          if (this.data.from === 'blank') this.currentStep = 1;
          if (this.data.from === 'template') this.currentStep = 1.2;
          if (this.data.from === 'report') this.currentStep = 1.3;
          break;
        case 1.2:
        case 1.3:
          this.currentStep = 1;
      }
    },
    useExisting(existing) {
      this.data.id = existing.id;
      this.data.from = existing.is_template ? 'template' : 'report';
      this.data.ga_version = existing.is_template ? existing.ga_version : null;
      this.data.contains_ga_widgets = existing.is_template ? existing.contains_ga_widgets : null;
      this.data.scope = existing.organisation_id ? 'organisation' : 'website';
      this.data.orientation = existing.orientation;
      this.data.paper_size = existing.paper_size;
      this.data.colors = existing.colors;
      this.data.logo_src = existing.logo_src;
      this.data.header_color = existing.header_color;
      this.data.header_text = existing.header_text;
      this.data.header_text_color = existing.header_text_color;
      this.data.header_font = existing.header_font;
      this.data.include_date_range = existing.include_date_range;
      this.data.footer_color = existing.footer_color;
      this.data.footer_text = existing.footer_text;
      this.data.footer_text_color = existing.footer_text_color;
      this.data.footer_font = existing.footer_font;
      this.data.include_page_number = existing.include_page_number;
    },
    setDates(dates) {
      this.data.date_range = dates.dateRange;
      this.data.comp_range = dates.compRange;
      this.data.from_date = dates.fromDate ? moment(dates.fromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') : null;
      this.data.to_date = dates.toDate ? moment(dates.toDate, 'YYYY-MM-DD').format('YYYY-MM-DD') : null;
      this.data.comp_from_date = dates.compFromDate ? moment(dates.compFromDate, 'YYYY-MM-DD').format('YYYY-MM-DD') : null;
      this.data.comp_to_date = dates.compToDate ? moment(dates.compToDate, 'YYYY-MM-DD').format('YYYY-MM-DD') : null;
    },
    async create() {
      this.currentStep = 3;

      if (this.type === 'report') {
        await this.createReport(this.data)
            .then(response => {
              this.created = true;
              this.report_id = response.id;
              this.currentStep = 4;
            })
            .catch(errors => {
              this.errors = errors;
              this.currentStep = 2;
            });
      } else {
        await this.createTemplate(this.data)
          .then(response => {
            this.created = true;
            this.report_id = response.id;
            this.currentStep = 4;
          })
          .catch(errors => {
            console.log(errors)
            this.errors = errors;
            this.currentStep = 2;
          });
      }
    },
    closeModal() {
      this.$emit('close');
    },
  },
}
</script>

<style scoped src="../../../../reports/css/modal.css" />

<style scoped>
.header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.header-wrapper div,
.header-wrapper h4 {
  margin: 0;
}

.header-wrapper button {
  position: initial;
}

.ga_version_info {
  background: #6ECADA;
  border-radius: 25px;
  color: #fff;
  font-size: 10px;
  padding: 5px 10px;
  text-align: center;
}

.ga_version_warning {
  text-align: center;
  background: #d47777;
  color: #FFFFFF;
  border-radius: 25px;
  font-size: 12px;
  padding: 5px 10px;
  margin-top: -1.75rem;
  margin-bottom: .25rem;
}

.create_report_modal .step_one_settings .create_settings .name_item.loading {
  cursor: default;
  justify-content: center;
}

.create_report_modal .step_one_settings .create_settings .name_item.loading:hover {
  background-color: white;
}
</style>
